import logger from '../logger/logger'
import { getCoreApiBaseUrl } from '@/utils/env'

export interface ReservationStateResponse {
  reservationState: string;
  idVerificationState: string;
}

async function getReservationState(reservationId: string) : Promise<ReservationStateResponse> {
	const apiHost = getCoreApiBaseUrl()

	try {
		const response = await fetch(`${apiHost}/reservation-state/${reservationId}`, {
			method: 'GET',
		})

		return await response.json()
	} catch (error) {
		logger.error('Could not fetch reservation state', error)

		throw error
	}
}

export default getReservationState
